import { appendAPExamTemplate } from '@/functions/idp'
import RIC from './RIC_2'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
